/* iJewel3D Cart Integration - Add metal color as product property */
(function () {
  const ijLog = (...args) => { try { console.log('[iJewel Cart]', ...args); } catch (_) {} };

  let lastColor = null;

  // Add metal color to form
  const addColorToForm = (form) => {
    const metalColor = window.iJewelSelectedMetalColor;
    
    if (metalColor) {
      ijLog('✓ Adding metal color to form:', metalColor);
      
      // Check if properties input already exists
      let propertiesInput = form.querySelector('input[name="properties[Metal Color]"]');
      
      if (!propertiesInput) {
        // Create hidden input for metal color property
        propertiesInput = document.createElement('input');
        propertiesInput.type = 'hidden';
        propertiesInput.name = 'properties[Metal Color]';
        form.appendChild(propertiesInput);
        ijLog('Created property input');
      }
      
      // Set the value
      propertiesInput.value = metalColor;
      ijLog('✓ Property value set to:', metalColor);
      return true;
    }
    
    ijLog('⚠ No metal color selected');
    return false;
  };

  // Method 1: Intercept form submissions
  const interceptCartForms = () => {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      
      // Check if this is a product form (add to cart)
      const isProductForm = form.getAttribute('action')?.includes('/cart/add') || 
                           form.closest('product-form') || 
                           form.id?.includes('product-form') ||
                           form.querySelector('[name="id"]'); // Has variant ID
      
      if (isProductForm) {
        ijLog('Form submission detected');
        addColorToForm(form);
      }
    }, true); // Use capture phase
  };

  // Method 2: Listen for button clicks
  const interceptAddToCartButtons = () => {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('button[name="add"], button[type="submit"]');
      if (!button) return;
      
      const form = button.closest('form');
      if (!form) return;
      
      const isProductForm = form.getAttribute('action')?.includes('/cart/add') ||
                           form.id?.includes('product-form') ||
                           form.querySelector('[name="id"]');
      
      if (isProductForm) {
        ijLog('Add to cart button clicked, preparing form');
        // Add with slight delay to ensure form is ready
        setTimeout(() => addColorToForm(form), 10);
      }
    }, true);
  };

  // Method 3: Listen for color changes and pre-populate forms
  const listenForColorChanges = () => {
    window.addEventListener('ijewel-color-changed', (e) => {
      const color = e.detail.color;
      ijLog('Color changed:', color);
      window.iJewelSelectedMetalColor = color;
      lastColor = color;
      
      // Pre-fill all product forms on page
      const forms = document.querySelectorAll('form[action*="/cart/add"], product-form form');
      forms.forEach(form => {
        let input = form.querySelector('input[name="properties[Metal Color]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[Metal Color]';
          form.appendChild(input);
        }
        input.value = color;
        ijLog('Pre-filled form with:', color);
      });
    });
  };

  // Debug logger
  const debugLogger = () => {
    setInterval(() => {
      const currentColor = window.iJewelSelectedMetalColor;
      if (currentColor && currentColor !== lastColor) {
        ijLog('Current metal color state:', currentColor);
        lastColor = currentColor;
      }
    }, 3000);
  };

  // Initialize all methods
  const init = () => {
    interceptCartForms();
    interceptAddToCartButtons();
    listenForColorChanges();
    debugLogger();
    ijLog('✓ Cart integration fully initialized');
  };

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
